import { Injectable } from "@angular/core";
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { UserService, APIUser } from "../shared/services/user.service";

@Injectable()
export class NotPublicUserGuard implements CanActivate {

    constructor(
        private userService: UserService,
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let user: APIUser = this.userService.getUserInfo()
        if (!user.info.is_public) {
            return true
        }
        this.router.navigateByUrl('/login');
        return false
    }

}